export const GRACE_PERIOD = import.meta.env.VITE_MEDPLUM_REFRESH_GRACE_PERIOD ?? 900000; // defaults to 15 minutes
